import {
    FETCH_APPOINTMENT_DETAILS_REQUEST,
    FETCH_APPOINTMENT_DETAILS_SUCCESS,
    FETCH_APPOINTMENT_DETAILS_FAILURE,
  } from "./FetchAppointmentDetailsTypes";
  
  const initialState = {
    loading: false,
    appointmentDetails: {},
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_APPOINTMENT_DETAILS_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_APPOINTMENT_DETAILS_SUCCESS:
        return {
          loading: false,
          appointmentDetails: action.payload,
          error: "",
        };
      case FETCH_APPOINTMENT_DETAILS_FAILURE:
        return {
          loading: false,
          appointmentDetails: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  